import { useLazyQuery } from '@apollo/client';
import { Button } from 'antd';
import { FC, useEffect, useMemo, useState } from 'react';
import { CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1Document, FileInfo } from '../../../../../../generated';
import { ReviewDocumentDocumentInfo, getDocumentInfo } from '../../../../../shared/review-documents/review-documents-helpers';
import { ReviewDocumentsModal } from '../../../../../shared/review-documents/review-documents-modal';

const DOCUMENT_CONFIG = {
  credential: { title: 'Credential' },
  translation: { title: 'Credential Translation' },
  'entity-supplied-credential': { title: 'Entity Supplied Credential' },
  'entity-translation-for-entity-supplied-credential': { title: 'Entity Supplied Credential Translation' },
  'verification-form.pdf': { title: 'Verification Form' },
  'verification-packet.pdf': { title: 'Verification Packet' },
  'verification-packet-response.pdf': { title: 'Verification Packet Response' },
  'verification-component-packet.pdf': { title: 'Verification Component Packet' }
} as ReviewDocumentDocumentInfo;

function useDocumentComparison(caseId: string) {
  const [isOpen, setIsOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [fetchFiles, { data }] = useLazyQuery(CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1Document);

  useEffect(() => {
    if (isFetching) {
      fetchFiles({
        variables: { id: caseId },
        fetchPolicy: 'network-only'
      }).then(() => {
        setIsFetching(false);
        setIsOpen(true);
      });
    }
  }, [isFetching, caseId]);

  const documentInfos = useMemo(() => {
    const files = data?.credentialVerificationCaseV1?.files as FileInfo[];
    return files?.length ? getDocumentInfo(files, DOCUMENT_CONFIG) : {};
  }, [data]);

  return {
    isOpen,
    isFetching,
    documentInfos,
    startComparison: () => setIsFetching(true),
    closeModal: () => {
      setIsOpen(false);
    }
  };
}
interface ReviewDocumentsButtonContainerProps {
  caseId: string;
}
export const ReviewDocumentsButtonContainer: FC<ReviewDocumentsButtonContainerProps> = (props) => {
  const { isOpen, isFetching, documentInfos, startComparison, closeModal } = useDocumentComparison(props.caseId);

  return (
    <>
      <Button loading={isFetching} onClick={startComparison}>
        Review Documents
      </Button>
      <ReviewDocumentsModal isOpen={isOpen} onClose={closeModal} documentInfos={documentInfos} />
    </>
  );
};
